import React from "react";

const BACK = 'M0,54 C220,110 430,4 720,44 C1010,84 1230,116 1440,58 L1440,145 L0,145 Z';
const FRONT = 'M0,86 C240,34 470,122 720,88 C980,52 1220,14 1440,62 L1440,145 L0,145 Z';

// Wave divider between sections. `fill` is the colour of the section the wave cuts into.
// Default: hangs off the bottom of its section. `flip`: sits just above the section.
// `overTop`: sits inside the top of the section, mirrored, over a full-bleed photo.
const Wave = ({fill, flip = false, height = 96, overTop = false}) => {
    const position = overTop
        ? {top: '-1px', transform: 'scaleY(-1)'}
        : {bottom: flip ? 'calc(100% - 1px)' : '-1px'};
    return (
        <div className="pb-wave" style={{...position, height: height + 'px'}}>
            <svg viewBox="0 0 1440 145" preserveAspectRatio="none" style={{opacity: 0.4, animationDuration: '17s'}}>
                <path d={BACK} fill={fill}/>
            </svg>
            <svg viewBox="0 0 1440 145" preserveAspectRatio="none" style={{animationDuration: '11s'}}>
                <path d={FRONT} fill={fill}/>
            </svg>
        </div>
    );
};

export default Wave;
